import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import get from 'lodash/get';
import withReducerSaga from 'yoda-site-components/lib/hoc/ReducerRegistry/withReducerSaga';
import PromoSMSEmailWrapper from './PromoSMSEmailWrapper';
import {
    submitPromotionalDetails,
    closePromotionalSuccessModal,
} from '../../../actions/AccountDetailsActions';
import { selectPromotionalSignUpContent } from '../../../selectors/walletBarcodeSelector';
import { getPromotionalSignUpContentAction } from '../../../actions/PromotionalSignUpActions';
import {
    promotionalAnalyticsAction,
    camAnalyticsAction,
} from '../../../actions/CAMDashboardActions';
import PromotionalSignUpReducer from '../../../reducers/PromotionalSignUpReducer';
import PromotionalSignUpSaga from '../../../sagas/PromotionalSignUpSaga';

function mapStateToProps(state) {
    return {
        messagesTexts: get(state, 'context.messagesTexts', {}),
        preferences: get(state, 'context.preferences', {}),
        featureFlags: get(state, 'context.featureFlags', {}),
        accountDetails: get(state, 'accountDetails', {}),
        deviceType: get(state, 'context.deviceType', 'desktop'),
        promotionalSignUpContent: selectPromotionalSignUpContent(state),
    };
}

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            promotionalAnalyticsAction,
            submitPromotionalDetails,
            closePromotionalSuccessModal,
            getPromotionalSignUpContentAction,
            camAnalyticsAction,
        },
        dispatch
    ),
});
export default compose(
    withReducerSaga([PromotionalSignUpReducer], [PromotionalSignUpSaga]),
    connect(mapStateToProps, mapDispatchToProps)
)(PromoSMSEmailWrapper);
